import _ from 'lodash';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'pension-segregation',
  computed: {
    getItem() {
      return _.cloneDeep(this.$store.getters['toolkit/getItemData']);
    },
    pensions() {
      return this.getItem.pensions;
    },
    activePension() {
      return this.getItem.activePension;
    },
    hasSegregation: {
      get() {
        return this.pensions[this.activePension].segregation.hasSegregation;
      },
      set(value) {
        if (value === 'No') {
          this.setItem({
            segregation: {
              hasSegregation: value,
              pensionAssets: undefined,
              segregatedPensionAssets: undefined,
            },
          });
        } else {
          this.setItem({ segregation: { hasSegregation: value } });
        }
      },
    },
    pensionAssets: {
      get() {
        return this.pensions[this.activePension].segregation.pensionAssets;
      },
      set(value) {
        this.setItem({ segregation: { pensionAssets: value } });
      },
    },
    segregatedPensionAssets: {
      get() {
        return this.pensions[this.activePension].segregation.segregatedPensionAssets;
      },
      set(value) {
        this.setItem({ segregation: { segregatedPensionAssets: value } });
      },
    },
  },
  methods: {
    setItem(data) {
      const updatedPension = _.merge(this.pensions[this.activePension], data);
      this.pensions[this.activePension] = updatedPension;
      this.$store.dispatch('toolkit/updateItemKey', { data: { pensions: this.pensions } });
    },
    handleBackStep() {
      this.$emit('backStep');
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
  },
  validations() {
    if (this.hasSegregation === 'No') {
      return {
        hasSegregation: {
          required,
        },
      };
    }
    return {
      hasSegregation: {
        required,
      },
      pensionAssets: {
        required,
      },
      segregatedPensionAssets: {
        required,
      },
    };
  },
};
